
import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, ArrowUpRight } from "lucide-react";
import "./Navbar.css";

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  const navigation = [
    { name: "Overview", path: "/overview" },
    { name: "Services", path: "/services" },
    { name: "Industries", path: "/industries" },
    { name: "About", path: "/about" },
    { name: "Contact", path: "/contact" },
  ];

  const isActive = (path) => {
    if (path === "/overview") {
      return (
        location.pathname === "/" ||
        location.pathname === "/overview"
      );
    }

    return location.pathname.startsWith(path);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <header className="navbar">
      <div className="navbar-container">
        {/* BRAND */}
        <Link
          to="/overview"
          className="navbar-brand"
          onClick={closeMenu}
        >
          <img
            src={`${process.env.PUBLIC_URL || ""}/logo.png`}
            alt="Nexis Fold Technologies"
            className="navbar-logo-image"
            onError={(event) => {
              console.error(
                "Logo image could not be loaded:",
                event.currentTarget.src
              );
            }}
          />

          <div className="navbar-company-name">
            <span className="navbar-company-main">
              NEXIS FOLD
            </span>

            <span className="navbar-company-sub">
              TECHNOLOGIES
            </span>
          </div>
        </Link>

        {/* NAVIGATION */}
        <nav
          className={`navbar-links ${
            menuOpen ? "navbar-links-open" : ""
          }`}
        >
          {navigation.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              onClick={closeMenu}
              className={
                isActive(item.path)
                  ? "navbar-link active"
                  : "navbar-link"
              }
            >
              {item.name}
            </Link>
          ))}
        </nav>

        {/* START PROJECT BUTTON */}
        <Link
          to="/contact"
          className="navbar-project-button"
          onClick={closeMenu}
        >
          <span>Start a Project</span>
          <ArrowUpRight size={17} />
        </Link>

        {/* MOBILE MENU BUTTON */}
        <button
          type="button"
          className="navbar-menu-button"
          onClick={() => setMenuOpen((previous) => !previous)}
          aria-label={menuOpen ? "Close navigation" : "Open navigation"}
          aria-expanded={menuOpen}
        >
          {menuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
    </header>
  );
}

export default Navbar;
